import * as React from 'react'
import {styled} from '@mui/material/styles'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic'
import {useUploadMediaMutation} from 'store/slices/api/uploadApi.js'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
})

export default function InputFileUpload({setFile, text, acceptedTypes}) {
    const [uploadMedia, {isLoading}] = useUploadMediaMutation()

    const handleFileChange = async (e) => {
        const file = e.target.files[0]
        const fileExtension = file.name.split('.').pop().toLowerCase()
        const formData = new FormData()
        formData.append('files', file)

        try {
            const {data} = await uploadMedia({
                body: formData,
            })
            const {fullLink: url} = data.files[0]
            setFile({name: file.name, url, fileExtension})
        } catch (e) {
            console.log('err', e)
        }
    }

    return (
        <Button
            component="label"
            variant="contained"
            disabled={isLoading}
            sx={{
                minWidth: '170px',
            }}
            startIcon={
                !isLoading ? (
                    <LibraryMusicIcon />
                ) : (
                    <CircularProgress size={24} />
                )
            }>
            {!isLoading ? text : ''}
            <VisuallyHiddenInput
                accept={acceptedTypes}
                type="file"
                onChange={handleFileChange}
            />
        </Button>
    )
}
